import { useState } from "react";

import { FALLBACK_COLLAGE_PRODUCTS } from "../constants/products";

export function useEditorState() {
  const [toast, setToast] = useState("");

  const [loading, setLoading] = useState(false);

  const [progress, setProgress] = useState({
    value: 0,
    message: "",
  });

  const [pieces, setPieces] = useState([]);

  const [img, setImg] = useState(null);

  const [originalFile, setOriginalFile] =
    useState(null);

  const [scale, setScale] = useState(1);

  const [offset, setOffset] = useState({
    x: 0,
    y: 0,
  });

const [grid, setGrid] = useState(
  FALLBACK_COLLAGE_PRODUCTS[1]
);

  const [fileName, setFileName] =
    useState("");

  return {
    toast,
    setToast,

    loading,
    setLoading,

    progress,
    setProgress,

    pieces,
    setPieces,

    img,
    setImg,

    originalFile,
    setOriginalFile,

    scale,
    setScale,

    offset,
    setOffset,

    grid,
    setGrid,

    fileName,
    setFileName,
  };
}
